// extracted by mini-css-extract-plugin
module.exports = {"containerLarge":"DirectoryTypeIcon__containerLarge","containerSmall":"DirectoryTypeIcon__containerSmall","icon":"DirectoryTypeIcon__icon"};